import App from './App.vue';

export default {
  path: '/CDS_VF_FirstAidDetail',
  name: 'CDS_VF_FirstAidDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '応急救護所詳細',
      controller: 'CDS_CTR_FirstAidDetail',
    },
  },
};
